import React, {Component} from "react";
import { Table } from "react-bootstrap";
import swal from 'sweetalert';
import Modal from "../../components/Modal";

class SelectSectionLab extends Component{
    constructor(props){
        super(props);

        this.openModal = this.openModal.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.onClear = this.onClear.bind(this);
        this.executeAction = this.executeAction.bind(this);


        this.state = {
            sections:[],
            action:'validation',
            checkAll:false
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    onCheck(e){
        var sections = this.state.sections;
        var num = 0, sect = sections.length;

		if(e.target.id === 'checkAll'){
			sections.forEach((s)=>{
				s.check = e.target.checked 
			})

			this.setState({checkAll:e.target.checked, sections:sections});
		}else{
			sections.forEach((s)=>{
				if(s.lab_section_id === parseInt(e.target.id)){
					s.check = e.target.checked 
				}
				
				if(s.check){num++;}
			})

			if(num === sect){
				this.setState({checkAll:true, sections:sections});
			}else{
				this.setState({checkAll:false, sections:sections});
			}
		}		
    }

    openModal(){
        var lab_sections = JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"));
		var section_lab = this.props.sections;
		var sections = [];
		
		lab_sections.forEach((s)=>{
			var valid = this.state.action === 'remove_lab' ? s.remove_validation : s.validate_results;

			if(valid){
				var index = section_lab.findIndex(obj => obj.ID === s.lab_sections_id);

				if(index !== -1){
					sections.push({
						check:false,
						lab_section_name:section_lab[index].Name,
						lab_section_id:section_lab[index].ID
					});
				}				
			}				
		});

        this.setState({sections: sections});
        this.modal.handleShow();
    }

    onClear(){
        this.setState({
            sections:[],
            action:'validation',
            checkAll:false
        });
    }

    executeAction(){
        var ids = [];
        this.state.sections.forEach((section)=>{
            if(section.check){
                ids.push(section.lab_section_id);
            }
        });

        if(ids.length > 0){
            if(this.state.action === 'validation'){
                this.props.onValidate(ids);
            }

            if(this.state.action === 'remove_lab'){
                this.props.onRemove(ids);
            }
            
            this.modal.handleClose();
        }else{
            swal('Error', 'Debe seleccionar por lo menos una sección', 'error');
        }
        
    }

    render(){
        return(
            <Modal
                title={
                    this.state.action === 'validation' ? 'Secciones a Validar' : 'Secciones a Retirar Validación'
                }
                actionBtn={true}
                label="Ejecutar"
                action={this.executeAction}
                clear={this.onClear}
                onRef={ref => this.modal = ref}
            >
                <div className="row">
                    <div className="col-xs-12">
                            <Table>
		        				<thead>
		        					<tr>
		        						<th>
		        							<input 
                                                type="checkbox" 
                                                id="checkAll" 
                                                onChange={(e)=>this.onCheck(e)} 
                                                checked={this.state.checkAll}
                                            />
		        						</th>
		        						<th>TODOS</th>
		        					</tr>
		        				</thead>
		        				<tbody>
		        					{this.state.sections.map((sect, i)=>(
		        						<tr key={i}>
		        							<td>
		        								<input 
                                                    type="checkbox" 
                                                    id={sect.lab_section_id} 
                                                    onChange={(e)=>this.onCheck(e)} 
		        									checked={sect.check} 
                                                />
		        							</td>
		        							<td>{sect.lab_section_name}</td>
		        						</tr>
		        					))}
		        				</tbody>
		        			</Table>
                    </div>
                </div>
            </Modal>
        )
    }    
}

export default SelectSectionLab;